var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit-content" },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        _vm._l(_vm.upElementBlocks, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "section form-column",
              style: { width: item.width + "px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.disabled,
                    "label-position": "right",
                    "label-width": "120px"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._l(item.elementNames, function(elementName) {
                    return [
                      _vm._t(elementName),
                      elementName === "jobNo"
                        ? [_vm._t("saleProductCode"), _vm._t("fullOrInside")]
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        }),
        0
      ),
      _vm.downElementBlock && _vm.downElementBlock.name === "cargoInfo"
        ? _c("div", { staticStyle: { "flex-direction": "column" } }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.disabled,
                      "label-position": "right",
                      "label-width": "120px"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.downElementBlock.title))
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "1100px",
                          display: "flex",
                          "flex-wrap": "wrap"
                        }
                      },
                      [
                        _vm._t("goodsInfo"),
                        _vm._l(_vm.downElementBlock.elementNames, function(
                          elementName,
                          index
                        ) {
                          return [
                            _vm.lineBreak.hasOwnProperty(elementName) &&
                            _vm.lineBreak[elementName]
                              ? [
                                  _c("div", {
                                    key: index,
                                    staticStyle: { width: "100%" }
                                  })
                                ]
                              : _vm._e(),
                            _vm._t(elementName)
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.downElementBlock && _vm.downElementBlock.name === "CargoInformation"
        ? _c("div", { staticStyle: { "flex-direction": "column" } }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.disabled,
                      "label-position": "right",
                      "label-width": "120px"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.downElementBlock.title))
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "1100px",
                          display: "flex",
                          "flex-wrap": "wrap"
                        }
                      },
                      [
                        _vm._l(_vm.downElementBlock.elementNames, function(
                          elementName,
                          index
                        ) {
                          return [
                            _vm.lineBreak.hasOwnProperty(elementName) &&
                            _vm.lineBreak[elementName]
                              ? [
                                  _c("div", {
                                    key: index,
                                    staticStyle: { width: "100%" }
                                  })
                                ]
                              : _vm._e(),
                            _vm._t(elementName)
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._t("ticketsInfo")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }